<form [formGroup]="datiGeneraliForm" (ngSubmit)="save()" *ngIf="request">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" />      

  <div class="row">
    <div comboModInput class="col-sm-6"
         [labelInput]="'Foro'" formControlName="foro"
         [optionsCombo] ="foriOptions"
         [objectReference]="request.fascicolo.foro"
         [(ngModel)]="request.fascicolo.foro"
         (onReturn)="request.fascicolo.foro = $event;"
         [mandatory]="true"
    ></div>

    <div checkBoxRadio class="col-sm-6"
         [labelInput]="'Conciliazione'" formControlName="conciliazione"
         idInput="conciliazione"
         [objectReference]="request.fascicolo.conciliazione"
         [(ngModel)]="request.fascicolo.conciliazione"
         (onReturn)="request.fascicolo.conciliazione = $event;"
         [mandatory]="true"></div>

  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]="!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
